var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{
            name: 'customer.show',
            params: { id: _vm.customer },
        }}},[_vm._v("\n        "+_vm._s(_vm.$t('customer.tabs.title'))+"\n    ")]),_c('v-tab',{attrs:{"to":{
            name: 'plan-proposal.index',
            params: { customer_id: _vm.customer },
        }}},[_vm._v("\n        "+_vm._s(_vm.$tc('resources.plan-proposal.name', 1))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }